import { customerRoutes } from 'noddi-util';
import { AppType, getExternalAppUrl, toWhitelabelBrand } from '../../utils/navigation';

export const formatRegistrationNumber = (value: string) => {
  const digits = value.replace(/\s/g, '');
  return digits.replace(/(.{3})(?=.)/g, '$1 ');
};

export const validateNorwegianOrganizationNumber = (value: string): string | undefined => {
  const digits = value.replace(/\s/g, '');

  if (!/^\d+$/.test(digits)) {
    return 'Norwegian organization number must contain only digits';
  }

  if (digits.length !== 9) {
    return `Norwegian organization number must be exactly 9 digits, got ${digits.length}`;
  }

  const weights = [3, 2, 7, 6, 5, 4, 3, 2];
  const checksum = weights.reduce((sum, weight, i) => sum + parseInt(digits[i]!) * weight, 0);
  const remainder = checksum % 11;

  const expectedCheckDigit = remainder === 0 ? 0 : 11 - remainder;

  if (expectedCheckDigit === 10) {
    return 'Invalid Norwegian organization number';
  }

  const actualCheckDigit = parseInt(digits[8]!);
  if (actualCheckDigit !== expectedCheckDigit) {
    return 'Invalid Norwegian organization number';
  }

  return undefined;
};

/** The customer app's public fleet calendar for a department, on the selected brand's domain. */
export const getDepartmentPublicCalendarUrl = (departmentSlug: string, brandSlug?: string | null) =>
  getExternalAppUrl({
    externalApp: AppType.Customer,
    route: customerRoutes.fleetCalendarPublic.getPath({ departmentSlug }),
    brand: toWhitelabelBrand(brandSlug)
  });
